import React, { useContext, useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Context } from '../../ContextApi/ContextApi';
import style from './index.module.css';

export default function Navbar() {
  const { user, setUser } = useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();
  const [isAccountVisible, setIsAccountVisible] = useState(false);

  useEffect(() => {
    console.log(user);
  }, [user]);

  const toggleAccountVisibility = (event) => {
    event.stopPropagation(); 
    setIsAccountVisible(!isAccountVisible);
  };

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (!event.target.closest(`.${style.account}`) && !event.target.closest(".fa-user")) {
        setIsAccountVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
  
    setIsAccountVisible(false);
  }, [location.pathname]);

  return (
    <div className="nvb">
      <nav>
        <div className={style.div1}>
          <div className={style.icons}>
            <NavLink onClick={toggleAccountVisibility}>
              <i className="fa-regular fa-user"></i>
            </NavLink>
            <NavLink to="/basket">
              <i className={`fa-solid fa-basket-shopping ${!user?.loggedIn ? style.disabled : ''}`}></i>
            </NavLink>
            <NavLink to="/wishlist">
              <i className={`fa-regular fa-heart ${!user?.loggedIn ? style.disabled : ''}`}></i>
            </NavLink>
           
          </div>

          {isAccountVisible && (
            <div className={style.account}>
              {user?.loggedIn ? (
                <>
                  <NavLink className="text-dark" to="/myaccount">My Account</NavLink><br />
                  <hr />
                  <NavLink className="text-dark" onClick={() => setUser(null)}>Logout</NavLink><br />
                </>
              ) : (
                <>
                  <NavLink className="text-dark" to="/login">Login</NavLink><br />
                  <hr />
                  <p>No account yet? <NavLink to="/registr">Register Here</NavLink></p>
                </>
              )}
              <hr />
              <NavLink className="text-dark">Language</NavLink><br /><hr />
            </div>
          )}

          <div className={style.nav}>
            <ul className={style.navbarul} type="none">
              {user?.role === 1 && <li><NavLink to="/user" className="text-dark">User</NavLink></li>}
              {user?.role === 1 && <li><NavLink to="/category" className="text-dark">Category</NavLink></li>}
              <li><NavLink to="/" className="text-dark">Home</NavLink></li>
              <li><NavLink to="/shop" className="text-dark">Shop</NavLink></li>
              <li><NavLink to="/about" className="text-dark">About</NavLink></li>
              <li><NavLink to="/contact" className="text-dark">Contact</NavLink></li>
            </ul>
          </div>

          <div className={style.logo}>
            <a>
              <img src="logo (2).png" alt="Logo" />
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
}
